import { VenuePastHolds, VenueUpcomingHolds } from '@features';
import { Stack } from '@mantine/core';

export const VenueDetailsHoldsPage: React.FC = () => {
  return (
    <Stack py="md" gap="xl">
      <VenueUpcomingHolds />
      <VenuePastHolds />
    </Stack>
  );
};
